<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1522 3.32192C24.4442 2.8927 23.5562 2.89269 22.8482 3.32191L5.43494 13.8781C4.59623 14.196 4 15.0068 4 15.9569V18.1791C4 19.4064 4.99492 20.4013 6.22222 20.4013H8.44444V35.9568H6.22222C4.99492 35.9568 4 36.9518 4 38.1791V42.6235C4 43.8508 4.99492 44.8457 6.22222 44.8457H41.7778C43.0051 44.8457 44 43.8508 44 42.6235V38.1791C44 36.9518 43.0051 35.9568 41.7778 35.9568H39.5556V20.4013H41.7778C43.0051 20.4013 44 19.4064 44 18.1791V15.9569C44 15.0072 43.4043 14.1967 42.5662 13.8786L25.1522 3.32192ZM34 20.4013V35.9568H26.7778V20.4013H34ZM21.2222 20.4013H14V35.9568H21.2222V20.4013Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
